import { rootReducer } from '..';

type RootState = ReturnType<typeof rootReducer>;

export const isVideoCallActiveSelector = (state: RootState) => state.videoCall.isActive;
